'use strict';

import { User } from './User';
import { Ind } from '../Ind/Ind';
import { Entity } from '../Entity';
import { UserCallLogSummaryCollection } from '../../Collections/User/UserCallLogSummaryCollection';
import { UserCallLogSummary } from './UserCallLogSummary';

export class UserCallLog extends Entity {
  protected id;
  protected user;
  protected ind;
  protected vendor;
  protected data;
  protected recording;
  protected dateTimeCreated;
  protected vendorCallID;
  protected userDescription;
  protected duration;
  protected direction;
  protected rawDate;
  protected summaries;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.vendor = data.vendor;
    this.data = data.data;
    this.dateTimeCreated = data.dateTimeCreated;
    this.recording = data.recording;
    this.vendorCallID = data.vendorCallID;
    this.userDescription = data.userDescription;
    this.duration = data.duration;
    this.direction = data.direction;
    this.rawDate = data.dateTimeCreated;

    if (data.user) {
      const user = new User();
      user.hydrate(data.user);

      this.user = user;
    }

    if (data.ind) {
      const ind = new Ind();
      ind.hydrate(data.ind);

      this.ind = ind;
    }

    if (data.dateTimeCreated) {
      const dateTimeCreatedDate = data.dateTimeCreated.date.split(' ')[0].split('-');
      const dateTimeCreatedTime = data.dateTimeCreated.date.split(' ')[1];

      this.dateTimeCreated =
        dateTimeCreatedDate[1] +
        '/' +
        dateTimeCreatedDate[2] +
        '/' +
        dateTimeCreatedDate[0] +
        ' ' +
        dateTimeCreatedTime;
    }

    if (data.summaries) {
      const summaries = new UserCallLogSummaryCollection();

      data.summaries.forEach((singleSummaryData) => {
        const summary = new UserCallLogSummary();
        summary.hydrate(singleSummaryData);

        summaries.addItem(summary);
      });

      this.summaries = summaries;
    }
  }

  public render() {
    switch (this.getVendor()) {
      case 'simplii':
        var data = this.getData();
        var theDate = new Date(data.start_time);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        return {
          id: this.getId(),
          description: data.description,
          direction: data.direction,
          outcome: data.outcome,
          recording: !this.getRecording() ? data.recording : this.getRecording,
          voicemail: data.voicemail !== undefined ? data.voicemail : false,
          startTime: theDateFinal,
          duration: data.duration,
          notes: data.notes,
          vendor: 'Simplii',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'zoom':
        var data = this.getData();
        var theDate = new Date(data.answer_time ? data.answer_time : data.date_time);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.direction.charAt(0).toUpperCase() + data.direction.slice(1),
          outcome: data.result,
          recording: this.getRecording(),
          voicemail: data.has_voicemail,
          startTime: theDateFinal,
          duration: data.duration,
          notes: '',
          vendor: 'Zoom',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'phonecom':
        var data = this.getData();

        var theDate = new Date(data.timestamp ? data.timestamp * 1000 : data.start_time);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.direction == 'outbound' ? 'Outbound' : 'Inbound',
          recording: this.getRecording(),
          startTime: theDateFinal,
          duration: data.call_duration || undefined,
          voicemail: data.voicemail_url ? data.voicemail_url : false,
          reference: this.getVendor(),
          notes: '',
          vendor: 'Phone.com',
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'ringcentral':
        var data = this.getData();

        if (data.body) {
          data = data.body;

          var theDate = new Date(data.eventTime);
          var day = theDate.getDate();
          var month = theDate.getMonth() + 1;
          var year = theDate.getFullYear();
          var hour = theDate.getHours();
          var minutes = theDate.getMinutes().toString().padStart(2, '0');
          var amPm = hour >= 12 ? 'pm' : 'am';
          var standardHour = hour >= 13 ? hour - 12 : hour;
          var theDateFinal =
            month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
          return {
            id: this.getId(),
            description: '',
            //direction: data.parties[0].direction.charAt(0).toUpperCase() + data.parties[0].direction.slice(1),
            direction: this.getDirection() === 's' ? 'Outbound' : 'Inbound',
            recording: this.getRecording(),
            voicemail: false,
            startTime: theDateFinal,
            duration: data.duration || null,
            notes: '',
            vendor: 'RingCentral',
            reference: this.getVendor(),
            vendorCallID: this.getVendorCallID(),
            userDescription: this.getUserDescription(),
          };
        } else {
          var theDate = new Date(data.startTime);
          var day = theDate.getDate();
          var month = theDate.getMonth() + 1;
          var year = theDate.getFullYear();
          var hour = theDate.getHours();
          var minutes = theDate.getMinutes().toString().padStart(2, '0');
          var amPm = hour >= 12 ? 'pm' : 'am';
          var standardHour = hour >= 13 ? hour - 12 : hour;
          var theDateFinal =
            month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
          return {
            id: this.getId(),
            description: '',
            direction: data.direction.charAt(0).toUpperCase() + data.direction.slice(1),
            outcome: data.result,
            recording: this.getRecording(),
            voicemail: false,
            startTime: theDateFinal,
            duration: data.duration,
            notes: '',
            vendor: 'RingCentral',
            reference: this.getVendor(),
            vendorCallID: this.getVendorCallID(),
            userDescription: this.getUserDescription(),
          };
        }

      case 'dialpad':
        var data = this.getData();
        var theDate = new Date(data.date_started);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        var summary = this?.getSummaries?.().getItems?.()[0] ?? [];
        return {
          id: this.getId(),
          description: '',
          direction: data.direction.charAt(0).toUpperCase() + data.direction.slice(1),
          outcome: data.result,
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: data.duration / 1000,
          notes: '',
          vendor: 'Dialpad',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
          summary: summary || [],
        };
      case 'openphone':
        var data = this.getData();
        var rawUtc = this.getRawDate(); // "2025-07-15 23:37:39"
        var utcIso = rawUtc.replace(' ', 'T') + 'Z';
        var theDate = new Date(utcIso); // now properly converted from UTC to local time

        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour % 12 || 12;

        var theDateFinal = `${month}/${day}/${year} @ ${standardHour}:${minutes} ${amPm}`;
        var summary = this?.getSummaries?.().getItems?.()[0] ?? [];

        return {
          id: this.getId(),
          description: '',
          direction: data.direction === 'incoming' ? 'Inbound' : 'Outbound',
          outcome: '',
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: this.getDuration(),
          notes: '',
          vendor: 'OpenPhone',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
          summary: summary || [],
        };
      case 'intulse':
        var data = this.getData();
        var theDate = new Date(data.activityDateUtc);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.isOutbound ? 'Outbound' : 'Inbound',
          outcome: '',
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: data.durationInSeconds,
          notes: data.notes,
          vendor: 'Intulse',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'dialedin':
        var data = this.getData();
        var theDate = new Date(this.getRawDate());
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;

        return {
          id: this.getId(),
          description: '',
          direction: data.direction === 'Manual' ? 'Outbound' : 'Inbound',
          outcome: '',
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: parseInt(data.duration),
          notes: '',
          vendor: 'DialedIn',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'goto':
        var data = this.getData();
        var theDate = new Date(data.answerTime);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;

        return {
          id: this.getId(),
          description: '',
          direction: data.direction == 'OUTBOUND' ? 'Outbound' : 'Inbound',
          outcome: '',
          recording: false,
          voicemail: false,
          startTime: theDateFinal,
          duration: data.duration,
          notes: '',
          vendor: 'GoTo Connect',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'talkdesk':
        var data = this.getData();
        var dateData = data.dateTimeCreated;
        var ex = dateData.split('T');
        var dateItem = ex[0].split('-');
        var timeItem = ex[1].split('.')[0].split(':');
        var hour = parseInt(timeItem[0]);
        var minute = timeItem[1];
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standard = hour >= 13 ? hour - 12 : hour;
        hour == 0 ? (hour = 12) : hour;
        var theDateFinal =
          dateItem[1] +
          '/' +
          dateItem[2] +
          '/' +
          dateItem[0] +
          ' @ ' +
          standard +
          ':' +
          minute +
          ' ' +
          amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.direction == 'outbound' ? 'Outbound' : 'Inbound',
          outcome: '',
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: data.duration,
          notes: '',
          vendor: 'TalkDesk',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'currentclient':
        var data = this.getData();
        var theDate = new Date(data.CreatedTime * 1000);

        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.Direction == 'OUTBOUND' ? 'Outbound' : 'Inbound',
          outcome: data.Status,
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: data.CallDurationTime,
          notes: '',
          vendor: 'CurrentClient',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'enrollhere':
        var data = this.getData();
        var theDate = new Date(this.getRawDate());
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var hour = theDate.getHours();
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = hour >= 12 ? 'pm' : 'am';
        var standardHour = hour >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + minutes + ' ' + amPm;
        const result = data?.call?.result ?? null;
        const operator =
          `${data?.call?.agent?.firstName ?? ''} ${data?.call?.agent?.lastName ?? ''}`.trim() ||
          null;

        return {
          id: this.getId(),
          description: '',
          direction: data.call.direction === 'INCOMING' ? 'Inbound' : 'Outbound',
          outcome: result,
          operator: operator,
          recording: this.getRecording() || false,
          voicemail: false,
          startTime: theDateFinal,
          duration: parseInt(this.duration),
          notes: '',
          vendor: 'EnrollHere',
          reference: this.getVendor(),
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
      case 'manual':
        var data = this.getData();
        var dateRaw = this.getDateTimeCreated();
        var theDate = new Date(dateRaw.split(' ')[0]);
        var day = theDate.getDate();
        var month = theDate.getMonth() + 1;
        var year = theDate.getFullYear();
        var theTime = dateRaw.split(' ')[1].split(':');

        var hour = parseInt(theTime[0]);
        var minutes = theDate.getMinutes().toString().padStart(2, '0');
        var amPm = theTime[0] >= 12 ? 'pm' : 'am';
        var standardHour = theTime[0] >= 13 ? hour - 12 : hour;
        var theDateFinal =
          month + '/' + day + '/' + year + ' @ ' + standardHour + ':' + theTime[1] + ' ' + amPm;
        return {
          id: this.getId(),
          description: '',
          direction: data.direction == 'outbound' ? 'Outbound' : 'Inbound',
          outcome: '',
          recording: false,
          voicemail: false,
          startTime: theDateFinal,
          duration: 0.0,
          notes: '',
          vendor: 'Manual',
          reference: 'manual',
          vendorCallID: this.getVendorCallID(),
          userDescription: this.getUserDescription(),
        };
    }
  }

  public getId() {
    return this.id;
  }

  public getUser() {
    return this.user;
  }

  public getInd() {
    return this.ind;
  }

  public getVendor() {
    return this.vendor;
  }

  public getData() {
    return this.data;
  }

  public getRecording() {
    return this.recording;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public getRawDate() {
    return this.rawDate.date;
  }

  public getVendorCallID() {
    return this.vendorCallID;
  }

  public getUserDescription() {
    return this.userDescription;
  }

  public getDuration() {
    return this.duration;
  }

  public getDirection() {
    return this.direction;
  }

  public getSummaries() {
    return this.summaries;
  }
}
